import React, { type PropsWithChildren } from 'react';
import { StyleSheet, View, type ViewStyle } from 'react-native';
import { theme } from '@garnish/constants';

export const LoyaltyPostPurchaseBody = (
  props: LoyaltyPostPurchaseBodyProps,
) => {
  const { children, style } = props;

  return <View style={[styles.bodyContainer, style]}>{children}</View>;
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  bodyContainer: {
    flex: 1,
    paddingHorizontal: theme.spacing['4'],
    paddingTop: theme.spacing['6'],
    paddingBottom: theme.spacing['10'],
    gap: theme.spacing['6'],
    alignItems: 'center',
  },
});

// ─── Types ───────────────────────────────────────────────────────────────────

type LoyaltyPostPurchaseBodyProps = PropsWithChildren<{
  style?: ViewStyle;
}>;
